import { BasketItemModel } from './BasketItemModel';
import { Type } from 'class-transformer';
import { ProductModel } from './ProductModel';

export class EntryModel {
    public quantity: number;

    public quantityAdded: number;

    public statusCode: string;

    @Type(() => ProductModel)
    public entry: BasketItemModel;
}